import { useState, useEffect, lazy } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import EnhancedSearchResults from "../../components/enhancedSearch/SearchResults/EnhancedSearchResults";
import SearchPagination from "../../components/enhancedSearch/SearchResults/SearchPagination.jsx";
import EnhancedSearchFilterSideBar from "../../components/enhancedSearch/SearchResults/SearchResultsFilterSideBar.jsx";
import styles from "./EnhancedSearchResultsPage.module.scss";
import useIsWebScreen from "../../hooks/useScreenSize.js";
import ModernWebLayout from "../../components/Layout/ModernWebLayout.jsx";
import MainContent from "../../components/Layout/MainContent.jsx";
import { selectTopicResults } from "./enhancedSearchSlice.js";

const TopicToolsSticky = lazy(
  () => import("../../components/topicToolsSticky.jsx"),
);

const ModernEnhancedSearchResultsPage = ({ isWebModernisationEnabled }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isDesktop } = useIsWebScreen();
  const searchResults = useSelector(selectTopicResults);

  const search = location.search;

  const [selectedTab, setSelectedTab] = useState(0);
  const [showFilterBar, setShowFilterBar] = useState(false);
  const [filterNumber, setFilterNumber] = useState(0);

  const [allGuidelines, setAllGuidelines] = useState({});
  const [selectedGuidelines, setSelectedGuidelines] = useState([]);
  const [searchWithin, setSearchWithin] = useState("");

  useEffect(() => {
    const searchParams = new URLSearchParams(search);
    const withinFromUrl = searchParams.get("searchWithin") || "";
    setSearchWithin(withinFromUrl);
  }, [search]);

  useEffect(() => {
    const selectedArray = searchResults?.selectedGuidelineFacets || [];
    const allFacets = searchResults?.avaiableGuidelineFacets || {};

    setSelectedGuidelines(selectedArray);
    setAllGuidelines(allFacets);
    setFilterNumber(selectedArray.length);
  }, [searchResults?.guidelineFacets, searchResults?.avaiableGuidelineFacets]);

  return (
    <ModernWebLayout title="Page Title">
      <MainContent className={styles.styledMainContent} padding="default">
        <div id="tgsearch">
          <div className={styles.mainContent}>
            <div className={styles.resultsWrapper}>
              <EnhancedSearchResults
                search={search}
                selectedTab={selectedTab}
                navigate={navigate}
                setSelectedTab={setSelectedTab}
                showFilterBar={showFilterBar}
                setShowFilterBar={setShowFilterBar}
                isWebModernisationEnabled={isWebModernisationEnabled}
              />
            </div>

            {showFilterBar && (
              <EnhancedSearchFilterSideBar
                search={search}
                navigate={navigate}
                setShowFilterBar={setShowFilterBar}
                setFilterNumber={setFilterNumber}
                className={styles.filterSidebar}
                allGuidelines={allGuidelines}
                searchWithin={searchWithin}
                setSearchWithin={setSearchWithin}
                selectedGuidelines={selectedGuidelines}
                setSelectedGuidelines={setSelectedGuidelines}
              />
            )}

            {!showFilterBar && isDesktop && (
              <div className={styles.filterButtonContainer}>
                <button
                  type="button"
                  onClick={() => setShowFilterBar(true)}
                  className={styles.filterButton}
                >
                  <i className="tg-icons-Filters size-14"></i>
                  <span className={styles.filterButtonText}>Filters</span>
                  {filterNumber > 0 && (
                    <div className={styles.counter}>{filterNumber}</div>
                  )}
                </button>
              </div>
            )}
          </div>

          {isDesktop && <SearchPagination selectedTab={selectedTab} />}
          <TopicToolsSticky pathname={location.pathname} />
        </div>
      </MainContent>
    </ModernWebLayout>
  );
};

export default ModernEnhancedSearchResultsPage;
